export default {
  options: {
    booleanTriState: {
      true: "Yes",
      false: "No",
    },
    recyclingStream: {
      paper_cardboard: "Paper and cardboard",
      plastics: "Plastics",
      glass: "Glass",
      metals: "Metals",
      wood: "Wood",
      textiles: "Textiles",
      organic: "Organic waste",
      mixed: "Mixed recycling",
      general: "General waste",
      deposit_return: "Deposit return system",
      specialist: "Specialist collection",
      not_defined: "Not yet defined",
      other: "Other",
    },
  },
};
